import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Box, Button, Checkbox, Menu, Snackbar, TableFooter, TablePagination } from '@material-ui/core';
import { MoreVertOutlined } from '@mui/icons-material';
import { TablePaginationActions } from './Pagination';
import { Alert, MenuItem } from '@mui/material';
import IconEditar from '../../../assets/images/NewEmployee/Icon-Editar.png'
import IconGestor from '../../../assets/images/NewEmployee/Icon-Gestor.png'
import IconWhatsApp from '../../../assets/images/NewEmployee/Icon-wpp.png'
import IconCopy from '../../../assets/images/NewEmployee/Icon-Copiar-Colar.png'
import IconRemove from '../../../assets/images/NewEmployee/Icon-Remover.png'
import IconOff from '../../../assets/images/NewEmployee/Icon-desligar.png'
import CustomDialog from './DemissionModal';


const useStyles = makeStyles({
    table: {
        minWidth: '100%',
    },
    header: {
        backgroundColor: '#f3f7fa',
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#fff',
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#f5f5f5',
        },
    },
    headerText: {
        fontSize: 12,
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        borderBottom: 'none',
        color: '#4e525a',
        whiteSpace: 'nowrap'
    },
    tableText: {
        fontSize: 10,
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        borderBottom: 'none',
        color: '#4e525a',
        whiteSpace: 'nowrap'
    },

});

const useStylesBotton = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
        display: 'flex',
    },
    activeButton: {
        backgroundColor: '#5aca5e', // Cor de fundo verde
        color: 'white', // Texto branco
        borderRadius: 20,
        width: '100%',
        '&:hover': {
            backgroundColor: '#388E3C', // Cor de fundo mais escura ao passar o mouse
        },
        textTransform: 'none',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    buttonCell: {
        textTransform: 'none',
        fontFamily: 'montserrat',
        color: '#8b8b8b',
        fontSize: 10,
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%'
    },
    menuPaper: {
        borderRadius: 15,
        width: 300,
        // marginLeft: -100,
        marginLeft: (window.innerWidth * 0.1) * -1,
        marginTop: 25,
        position: 'fixed',
        display: 'flex', // Adicionado para habilitar o alinhamento flexível
        justifyContent: 'center', // Centraliza horizontalmente
        alignItems: 'center',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%', // Centraliza a seta verticalmente
            right: -20, // Move a seta para a direita do menu
            width: 0,
            height: 0,
            borderTop: '20px solid transparent', // Aumenta o tamanho da seta
            borderBottom: '20px solid transparent', // Aumenta o tamanho da seta
            borderLeft: `20px solid ${theme.palette.background.paper}`,
            transform: 'translateY(-50%)'
        },
        overflow: 'visible'
    }
}));


export default function EmployeeTable({

    tableState,
    viewEmployeeRegistration
}) {
    const classes = useStyles();
    const classesBotton = useStylesBotton();


    return (
        <TableContainer component={Paper} style={{ marginTop: 27 }}>
            <Snackbar
                open={viewEmployeeRegistration.openMessage}
                autoHideDuration={3000}
                onClose={() => viewEmployeeRegistration.setOpenMessage(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Adicionei esta linha
            >
                <Alert onClose={() => viewEmployeeRegistration.setOpenMessage(false)}
                    severity="success"
                    sx={{ width: '100%', backgroundColor: 'white', color: 'green' }}
                >
                    {viewEmployeeRegistration.messageSuccess}
                </Alert>
            </Snackbar>
            <Table className={classes.table} aria-label="simple table">
                <TableHead className={classes.header}>
                    <TableRow>
                        <TableCell padding="checkbox">
                            <Checkbox
                                indeterminate={tableState.numSelected > 0 && tableState.numSelected < tableState.rowCount}
                                checked={tableState.rowCount > 0 && tableState.numSelected === tableState.rowCount}
                                onChange={tableState.handleSelectAllClick}
                                inputProps={{ "aria-label": "select all desserts" }}
                                color='primary'
                                size='small'
                            />
                        </TableCell>

                        <TableCell align="center" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Colaborador</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Dados pessoais</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Departamento</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Escala</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Banco de Horas</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Restrições</TableCell>
                        <TableCell align="left" size="medium" className={classes.headerText} style={{ padding: 4.5 }}>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(tableState.rowsPerPage > 0
                        ? tableState.employee.slice(tableState.page * tableState.rowsPerPage, tableState.page * tableState.rowsPerPage + tableState.rowsPerPage)
                        : tableState.employee
                    ).map((row, index) => (
                        <TableRow key={index} className={classes.row}>
                            <TableCell align="center" className={classes.tableText} style={{ padding: 4.5 }} padding="checkbox">
                                <Checkbox
                                    checked={tableState.selected.includes(row.name)}
                                    onChange={(event) => tableState.handleSelectOneClick(event, row.name, row)}
                                    color='primary'
                                    size='small' // diminui o tamanho do checkbox
                                />
                            </TableCell>

                            <TableCell align="center" className={classes.tableText} style={{ padding: 4.5 }}>
                                {tableState.limitarString(tableState.capitalizeFirstLetter(row.name), 20)}
                            </TableCell>
                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <Box display="flex" justifyContent="flex-start" alignItems="center" style={{ height: '100%' }}>
                                    <Button
                                        className={classesBotton.buttonCell}
                                    // onClick={() => tableState.handleClickOpenModalInformation(row)}
                                    >
                                        Completo
                                    </Button>

                                    <div></div> {/* Espaço vazio à direita */}
                                </Box>
                            </TableCell>
                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ height: '100%' }}>
                                    <Button
                                        className={classesBotton.buttonCell}
                                    >
                                        {tableState.capitalizeFirstLetter(row.department)}
                                    </Button>
                                    <div></div> {/* Espaço vazio à direita */}
                                </Box>
                            </TableCell>


                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ height: '100%' }}>
                                    <Button
                                        className={classesBotton.buttonCell}
                                    >
                                        {row._workingDay ? tableState.limitarString(tableState.capitalizeFirstLetter(row._workingDay), 20) : 'Sem escala'}
                                    </Button>
                                    <div></div> {/* Espaço vazio à direita */}
                                </Box>
                            </TableCell>
                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ height: '100%' }}>
                                    <Button
                                        className={classesBotton.buttonCell}
                                    >
                                        {row.BankHoursEmployee ? 'Ativado' : 'Desativado'}
                                    </Button>
                                    <div></div> {/* Espaço vazio à direita */}
                                </Box>
                            </TableCell>
                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ height: '100%' }}>
                                    <Button
                                        className={classesBotton.buttonCell}
                                    >
                                        {row.restrictions ? tableState.capitalizeFirstLetter(row.restrictions) : 'Sem restrições'}
                                    </Button>
                                    <div></div> {/* Espaço vazio à direita */}
                                </Box>
                            </TableCell>
                            <TableCell align="left" size="medium" style={{ padding: 4.5, borderBottom: 'none', }}>
                                <div className={classesBotton.root}>
                                    {/* <MoreVertOutlined
                                        style={{ fontSize: 18, fontWeight: 'bold', color: '#8b8b8b', marginTop: 14, marginLeft: -6 }} /> */}
                                    <Button
                                        variant="contained"
                                        className={classesBotton.activeButton}
                                        style={{
                                            backgroundColor: row.isManager && row.admission == undefined ? '#484fdb' : row.admission ? '#dc1718' : row.userId == null ? '#ff9801' : '#5aca5e',
                                            marginLeft: -4
                                        }}
                                        onClick={event => tableState.handleClickMenu(event, row)}
                                    >
                                        {row.isManager && row.admission == undefined ? 'Gestor' : row.admission ? 'Desligado' : row.userId == null ? 'Pendente' : 'Ativo'}
                                    </Button>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={8} style={{ borderBottom: 'none' }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', borderBottom: 'none' }}>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                    count={tableState.employee.length}
                                    rowsPerPage={tableState.rowsPerPage}
                                    page={tableState.page}
                                    SelectProps={{
                                        inputProps: { "aria-label": "itens por página", style: { fontSize: '0.8rem' } },
                                        style: { fontSize: '0.8rem' }
                                    }}
                                    onChangePage={tableState.handleChangePage}
                                    onChangeRowsPerPage={tableState.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                    labelRowsPerPage={<span style={{ fontSize: '0.8rem' }}>Itens por página:</span>}
                                    labelDisplayedRows={({ from, to, count }) => <span style={{ fontSize: '0.8rem' }}>{`${from}-${to} de ${count}`}</span>}
                                />

                            </div>
                        </TableCell>
                    </TableRow>
                </TableFooter>


            </Table>
            <div>
                <Menu
                    id="account-menu"
                    anchorEl={tableState.anchorEl}
                    keepMounted
                    open={Boolean(tableState.anchorEl)}
                    onClose={tableState.handleCloseMenu}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        className: classesBotton.menuPaper,
                    }}
                >
                    <MenuItem onClick={viewEmployeeRegistration.handleViewRegistration} style={{ ...stylesMenu.menuButton, marginTop: 10 }}>
                        <img src={IconEditar} alt="descrição da imagem" style={stylesMenu.img} />
                        <a style={{ marginLeft: 15 }}>Editar Colaborador</a>
                    </MenuItem>
                    {
                        tableState.row.isManager ?
                            <MenuItem onClick={tableState.removeGestor} style={stylesMenu.menuButton} >
                                <img src={IconGestor} alt="descrição da imagem" style={stylesMenu.img} />
                                <a style={{ marginLeft: 15 }}>Remover como Gestor</a>
                            </MenuItem>
                            :
                            null
                    }
                    {
                        !tableState.row.userId && !tableState.row.admission && !tableState.row.isManager ?
                            <>
                                <MenuItem onClick={
                                    () => {
                                        let decodedPhone = decodeURIComponent(viewEmployeeRegistration.row.phone);
                                        let whatsappPhone = decodedPhone.replace(/\D/g, '');
                                        window.open(`https://wa.me/55${whatsappPhone}?text=${encodeURIComponent(viewEmployeeRegistration.message)}`, '_blank');
                                        // usageLog('firtEmployee/ButtonWhatsApp', decodedToken.companyId, decodedToken.id);
                                        // Limpar os parâmetros da URL

                                    }
                                }
                                    style={stylesMenu.menuButton}
                                >
                                    <img src={IconWhatsApp} alt="descrição da imagem" style={stylesMenu.img} />
                                    <a style={{ marginLeft: 15 }}>Enviar convite pelo WhatsApp</a>
                                </MenuItem>
                                <MenuItem onClick={viewEmployeeRegistration.copyToClipboard} style={stylesMenu.menuButton}>
                                    <img src={IconCopy} alt="descrição da imagem" style={stylesMenu.img} />
                                    <a style={{ marginLeft: 15 }}>Copiar mensagem do convite</a>
                                </MenuItem>
                            </>
                            :
                            null
                    }

                    <div style={stylesMenu.divLine} />
                    {
                        tableState.row.admission ?
                            <MenuItem onClick={tableState.reactivateEmployee} style={stylesMenu.menuButton}>
                                <img src={IconRemove} alt="descrição da imagem" style={stylesMenu.img} />
                                <a style={{ marginLeft: 15 }}>Reativar</a>
                            </MenuItem>
                            :
                            <MenuItem onClick={tableState.handleClickDemission} style={stylesMenu.menuButton}>
                                <img src={IconOff} alt="descrição da imagem" style={stylesMenu.img} />
                                <a style={{ marginLeft: 15 }}>Desligar</a>
                            </MenuItem>
                    }

                </Menu>
            </div>
            <CustomDialog open={tableState.openModalDemission} onClose={tableState.setOpenModalDemission} data={viewEmployeeRegistration} tableState={tableState} />
        </TableContainer>
    );
}

const stylesMenu = {
    menuButton: {
        fontFamily: 'montserrat',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#3d434c',
        marginLeft: 16
    },
    img: {
        width: '6%',
        height: 'auto',
    },
    divLine: {
        height: '2px',
        width: '20%',
        margin: '10px auto',
        borderBottom: '1px dashed gray',
        marginLeft: 60,
        fontWeight: 'bold'
    }
}
